import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=3fb6edf1"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports